import { useMutation } from "@vue/apollo-composable";
import {
  CreateAccountPayeeDocument,
  CreateBillerPayeeDocument,
  CreatePayIdPayeeDocument,
  DeletePayeeDocument,
  PayeesDocument,
} from "@/api/generated/graphql";
import type { CreateAccountPayee, CreateBillerPayee, CreatePayIdPayee } from "@/api/generated/graphql";

export const payeesQuery = PayeesDocument;

export enum PayeeType {
  accountPayee = "AccountPayee",
  billerPayee = "BillerPayee",
  payIdPayee = "PayIdPayee",
}

export async function createAccountPayee({ name, bsb, accountNumber }: CreateAccountPayee) {
  const { onDone, onError, mutate } = useMutation(CreateAccountPayeeDocument);
  const res = new Promise((resolve, reject) => {
    onDone(result => resolve(result));
    onError(error => reject(error));
  });
  await mutate({ payee: { name, bsb, accountNumber } });
  return res;
}

export async function createBillerPayee({ name, billerCode, crn }: CreateBillerPayee) {
  const { onDone, onError, mutate } = useMutation(CreateBillerPayeeDocument);
  const res = new Promise((resolve, reject) => {
    onDone(result => resolve(result));
    onError(error => reject(error));
  });
  await mutate({ payee: { name, billerCode, crn } });
  return res;
}

export async function createPayIdPayee({ name, payId, payIdType }: CreatePayIdPayee) {
  const { onDone, onError, mutate } = useMutation(CreatePayIdPayeeDocument);
  const res = new Promise((resolve, reject) => {
    onDone(result => resolve(result));
    onError(error => reject(error));
  });
  await mutate({ payee: { name, payId, payIdType } });
  return res;
}

export async function deletePayee({ payeeId }: { payeeId: string }) {
  const { onDone, onError, mutate } = useMutation(DeletePayeeDocument);
  const res = new Promise((resolve, reject) => {
    onDone(result => resolve(result));
    onError(error => reject(error));
  });
  await mutate({ payeeId });
  return res;
}
